import React from 'react';
import glamorous from 'glamorous';
import {CHARCOAL, WHITE} from '../../../shared/style/colors';
import {FONTS, WEIGHT} from '../../../shared/style/typography';
import {PHONE} from '../../../shared/style/breakpoints';
import RequestDemo from './request-demo';

const Container = glamorous.div({
  backgroundColor: CHARCOAL,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  width: '100%',
  paddingBottom: 40
});

const Title = glamorous.h3({
  fontFamily: FONTS.CEREBRI_SANS_PRO,
  fontWeight: WEIGHT.ULTRA_BLACK,
  fontSize: 40,
  lineHeight: '50px',
  color: WHITE,
  marginTop: 93,
  marginBottom: 32,
  [PHONE]: {
    padding: '0 20px',
    fontSize: 24,
    margin: '62px 0 26px',
    textAlign: 'center'
  }
});

const CtaContainer = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  [PHONE]: {
    width: '85%',
    flexDirection: 'column'
  }
});

const FooterCta = () => {
  return (
    <Container>
      <Title>Got questions? Let us give you a tour.</Title>
      <CtaContainer>
        <RequestDemo
          eventProperties={{
            index: 1,
            sectionName: 'SignupHeader'
          }}
          extraStyle={{
            fontFamily: FONTS.CEREBRI_SANS_PRO,
            width: 242,
            minWidth: 242,
            fontSize: 20,
            fontWeight: 700,
            lineHeight: 39
          }}
        />
      </CtaContainer>
    </Container>
  );
};

export default FooterCta;
